module.exports = __webpack_public_path__ + "static/media/pharma.b6b09bff.png";